import { Translate } from 'react-redux-i18n'
import { Icon } from '../../../../common/html/icon'
import classes from './index.module.scss'
import { Element } from '../../../../common/html/element'
import { useNavigate } from 'react-router'
import { COMPONENTS } from '../../../../routers/constants'

export const BackButton = () => {
  const navigate = useNavigate()

  const onClick = () => {
    navigate(COMPONENTS.userManagement.components.subscriptionPayment.route)
  }

  return (
    <div className="dFlex">
      <Element
        elementName="span"
        className={classes.backButton}
        style={{ border: '1px solid #d5d5d5' }}
        onClick={onClick}
      >
        <Icon className="icon-arrow-left" style={{ fontSize: 10 }} />
        <Translate value="userManagement.orderManagement.orderDetail.BACK_TO_SUBSCRIPTION_PAYMENT" />
      </Element>
    </div>
  )
}
